import React from 'react';
import SiteNavbar from './SiteNavbar'

const Header = () => {
    return(
        <header id="main-header">
            <SiteNavbar/>
        </header>
    );
};

export default Header;